
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forex/buy-forex-card",
      function () {
        return require("private-next-pages/forex/buy-forex-card.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forex/buy-forex-card"])
      });
    }
  